import { render, staticRenderFns } from "./GlobalLoaderIndicator.vue?vue&type=template&id=6b195690&scoped=true&"
import script from "./GlobalLoaderIndicator.vue?vue&type=script&lang=js&"
export * from "./GlobalLoaderIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b195690",
  null
  
)

export default component.exports